<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '#' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>首页菜单</el-breadcrumb-item>
        <el-breadcrumb-item>首页</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <el-row>
          <el-col :push="10">
              <h2>武汉联一合立欢迎您!</h2>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-link href="#/robot" type="primary"  style="font-size:25px;"> 机器人数量: <span>{{onLineTotal}}</span>/<span>{{total}}</span></el-link><span style="float:right" >在线/总</span> 
            <el-progress :percentage="percentage"></el-progress>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-carousel type="card" height="450px">
            <el-carousel-item v-for="item in imgs" :key="item.url">
              <img :src="item.url"  height="500" width="860"/>
            </el-carousel-item>
          </el-carousel>
        </el-row>
        <el-row > 
          <el-col :span="8" :push="3" >
              <h1>服务热线：027-87003468</h1>
          </el-col>
          <el-col :span="8" :push="3" >
              <h1>售后支持：400-601-6858</h1>
          </el-col>
          <el-col :span="8" :push="3" >
            <el-row>
                  <el-col :span="6">
                    <h1>服务微信号:</h1>
                  </el-col>
                  <el-col :span="6" :pull="1" >
                    <img src="../../assets/qrcode.jpg"  height="120" width="120"  style="position:absolute; top:-35px;"/>
                  </el-col>
              </el-row>
          </el-col>
        </el-row>
    </el-card >
  </div>
</template>

<script>


export default {
  name: 'machine',
  data(){
      return {
        imgs: [
                {url: require('../../assets/1.png'), link: '/content1'},
                {url: require('../../assets/2.png'), link: '/content1'},
                {url: require('../../assets/3.png'), link: '/content1'}
              ]
              ,
        percentage:0,
        total:0,
        onLineTotal:0,
        href:''
      }
  },
   //生命周期函数
  created(){
    this.selectRobotTotal()
  },
  methods:{
      selectRobotTotal(){
        let that=this
        this.$http.get('robot/selectRobotCount') .then(response => {
          if (response.data.code === 200) {      
              //that.href=this.$router.replace({path: '/robot'})                    
              that.total=    response.data.result.total
              that.onLineTotal= response.data.result.countOnLine
              that. percentage=((that.onLineTotal/that.total)*100).toFixed(0)*1
              
          }
        })
      }
  }
  
}
</script>

<style lang="less" scoped>
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
 .el-icon-plus{
        font-size:30px; //改变图标大小
        line-height: 110px; //通过设置行高让图标垂直居中
        color: #409EFF;  //设置图标颜色
}
</style>


// WEBPACK FOOTER //
// src/components/robot/Welcome.vue